export const bizNameMap = {
  iwan: 'iwan',
  weishi: 'weishi',
  sports: 'sports',
  yyb: 'yyb',
};
